import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { Integration } from './integration'

export class IntegrationsRepository extends BaseRepository<Integration> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.eventApiUrl + '/' + 'integrations', token, cache)
    }
}
